import React from 'react';

const MarkdownComponents = {
  h1: ({ children }) => <div className="ev-med-p-blue mb-2 mt-2">{children}</div>,
  h2: ({ children }) => <div className="ev-reg-p-dark mb-1 mt-2 fw-bold">{children}</div>,
  h3: ({ children }) => <div className="ev-reg-p-dark mb-1 mt-2 fw-bold">{children}</div>,
  h4: ({ children }) => <div className="ev-small-p-blue mb-1 mt-2 fw-bold">{children}</div>,
  h5: ({ children }) => <div className="ev-small-p-blue mb-1 mt-2 fw-bold">{children}</div>,
  h6: ({ children }) => <div className="ev-small-p-blue mb-1 mt-2 fw-bold">{children}</div>,
  p: ({ children }) => <div className="ev-reg-p-dark mb-2 mt-1">{children}</div>,
  li: ({ children }) => <li className="ev-reg-p-dark mb-1">{children}</li>,
};

export default MarkdownComponents;